import React, { useEffect, useContext, createContext, useRef } from 'react';
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Rout from './components/Rout';
import { CartProvider } from './components/CartContext';
import { OrdersProvider } from './components/OrdersContext';
import OrdersContext from './components/OrdersContext';
import Chatbot from "./components/Chatbot";

// ── Posts cache ───────────────────────────────────────────────────────────────
// Stored outside React so it survives unmount/remount of Home.
// When user navigates away and comes back, Home reads from this cache
// instantly instead of waiting for a fresh API call.
export const PostsCacheContext = createContext({ current: null });

function AppContent() {
  const { fetchOrdersCount } = useContext(OrdersContext);
  const location = useLocation();

  useEffect(() => {
    // Fixed: was reading 'userid' (wrong key) — now reads 'user_id'
    // Previously this fired fetchOrdersCount(null) on every route change
    const userId = localStorage.getItem("user_id");
    if (userId && userId !== 'undefined' && userId !== 'null') {
      fetchOrdersCount(userId);
    }
  }, [location.pathname]); // only re-run on actual route changes

  const hideChatbot = location.pathname === "/";

  return (
    <div className="App">
      <Rout />
      {!hideChatbot && <Chatbot />}
    </div>
  );
}

function App() {
  // postsCache is a ref — persists for the lifetime of the app,
  // survives page navigation, never causes re-renders
  const postsCache = useRef(null);

  return (
    <Router>
      <PostsCacheContext.Provider value={postsCache}>
        <CartProvider>
          <OrdersProvider>
            <AppContent />
          </OrdersProvider>
        </CartProvider>
      </PostsCacheContext.Provider>
    </Router>
  );
}

export default App;